var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-container"},[_c('SubMenu',{attrs:{"nav-list":_vm.navList,"opened-menus":_vm.openedMenus,"default-path":_vm.path},on:{"select":_vm.onSelect,"clickSubMenu":_vm.onClickSubMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }